"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EcoLineRebalanced = void 0;
var Card_1 = require("../../Card");
var Tags_1 = require("../../Tags");
var Resources_1 = require("../../../Resources");
var CardName_1 = require("../../../CardName");
var CardType_1 = require("../../CardType");
var CardRenderer_1 = require("../../render/CardRenderer");
var DeferredAction_1 = require("../../../deferredActions/DeferredAction");
var OrOptions_1 = require("../../../inputs/OrOptions");
var SelectOption_1 = require("../../../inputs/SelectOption");
var EcoLineRebalanced = (function (_super) {
    __extends(EcoLineRebalanced, _super);
    function EcoLineRebalanced() {
        return _super.call(this, {
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.ECOLINE_REBALANCED,
            tags: [Tags_1.Tags.PLANT],
            startingMegaCredits: 37,
            metadata: {
                cardNumber: 'R17',
                description: 'You start with 3 plant production, and 37 M€.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.br;
                    b.production(function (pb) { return pb.plants(3); }).nbsp.megacredits(37);
                    b.corpBox('effect', function (ce) {
                        ce.effect('Each time you play a plant, animal or microbe tag, including this, gain 2MC or 1 plant.', function (eb) {
                            eb.animals(1).played.slash().plants(1).played.slash().microbes(1).played;
                            eb.startEffect.megacredits(2).or().plants(1);
                        });
                    });
                }),
            },
        }) || this;
    }
    EcoLineRebalanced.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.PLANTS, 3);
        this.gainBonus(player, 1);
        return undefined;
    };
    EcoLineRebalanced.prototype.gainBonus = function (player, amount) {
        for (var i = 0; i < amount; i++) {
            if (player.plants < 0) {
                player.plants += 1;
            }
            else {
                player.game.defer(new DeferredAction_1.DeferredAction(player, function () {
                    return new OrOptions_1.OrOptions(new SelectOption_1.SelectOption('Gain 2 MC', 'Gain MC', function () {
                        player.addResource(Resources_1.Resources.MEGACREDITS, 2, { log: true });
                        return undefined;
                    }), new SelectOption_1.SelectOption('Gain 1 plant', 'Gain plant', function () {
                        player.addResource(Resources_1.Resources.PLANTS, 1, { log: true });
                        return undefined;
                    }));
                }));
            }
        }
        return undefined;
    };
    EcoLineRebalanced.prototype.onCardPlayed = function (player, card) {
        if (player.corporationCard !== undefined && player.corporationCard.name === this.name) {
            var amount = card.tags.filter(function (tag) { return tag === Tags_1.Tags.ANIMAL || tag === Tags_1.Tags.PLANT || tag === Tags_1.Tags.MICROBE; }).length;
            if (amount > 0) {
                this.gainBonus(player, amount);
            }
        }
    };
    return EcoLineRebalanced;
}(Card_1.Card));
exports.EcoLineRebalanced = EcoLineRebalanced;
//# sourceMappingURL=EcoLineRebalanced.js.map